import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import action from "../../../../store/action";

import store from "../../../../store";

import { cloneDeep } from "lodash";

import {
  getGumData,
  getToothData,
  getToothUrl,
  getToothVisible,
  getToothMatrix,
  getToothFileType,
} from "../../../../dataInterface/index";
import SuperimpositionModel from "../../../../Components/CreateModal/SuperimpositionModel";
import toothManager from "../../../../data/manager/toothManager";
import { getOpacity } from "../../../../common/tooth";
import gumManager from "../../../../data/manager/gumManager";

function SuperimpositionPro2(props) {
  const { overlayCheckboxValue, sliderVal, keyframeNumber } = props;

  const toothModelList = useMemo(() => toothManager.getToothModelList(), []);


  const superimpositionStageNumber = 1;
  const stageNumber = keyframeNumber + 1;

  return (
    <group name={"overlayToothGroup"} visible={overlayCheckboxValue}>
      {toothModelList.map((toothModel) => {
        const { toothGumType, toothNumber, toothIndex, model } = toothModel;
        const superimpositionToothMatrix =
          toothManager.getToothMatrixByStageNumberAndToothGumTypeAndToothIndex(
            superimpositionStageNumber,
            toothGumType,
            toothIndex
          );

        const superimpositionGumMatrix = gumManager.getGumMatrixByStageNumberAndToothGumType(
          superimpositionStageNumber,
          toothGumType
        );

        const gumMatrix = gumManager.getGumMatrixByStageNumberAndToothGumType(
          stageNumber,
          toothGumType
        );

        const modelMatrix = cloneDeep(superimpositionGumMatrix).invert().multiply(cloneDeep(superimpositionToothMatrix));

        const opacity = getOpacity(toothGumType, sliderVal);

        return (
          <group matrix={gumMatrix} matrixAutoUpdate={false}>
            <group
              matrix={modelMatrix}
              matrixAutoUpdate={false}
              name={toothNumber}
              visible={true}
            >
              <SuperimpositionModel model={model} opacity={opacity} />
            </group>
          </group>
        );
      })}
    </group>
  );
}

const mapStateToProps = (state) => ({
  sliderVal: state.webViewer.sliderVal,
  keyframeNumber: state.webViewer.keyframeNumber,
  overlayCheckboxValue: state.webViewer.overlayCheckboxValue,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperimpositionPro2);
